import "./tucan-logo.css";
const TucanLogo = ({ className = "" }) => {
	return (
		<p></p>
	);
};

export default TucanLogo;
